import { MarkdownRender } from '@gov-nx/component/web';
import { useLocale } from '@gov-nx/core/service';
import {
	PageCode,
	useDatovkaNastaveniUpozorneniContext,
} from '@gov-nx/module/page';
import { Button, Dialog } from '@gov-nx/ui/web';

export const DataboxConfirmExtendedMailNotificationModal = () => {
	const { t } = useLocale(PageCode['datove-schranky']);

	const { isConfirmModalOpen, handleModalConfirm, handleModalCancel } =
		useDatovkaNastaveniUpozorneniContext();

	return (
		<Dialog
			isOpen={isConfirmModalOpen}
			onClose={handleModalCancel}
			title={
				<h3>{t('nastaveni-upozorneni.souhlas-se-vstupovanim-do-schranky')}</h3>
			}
			footer={
				<>
					<Button
						nativeType="button"
						color="primary"
						type="base"
						size="m"
						onClick={handleModalCancel}
						aria-label={t('nastaveni-upozorneni.souhlas-odmitnout')}>
						{t('nastaveni-upozorneni.souhlas-odmitnout')}
					</Button>
					<Button
						nativeType="button"
						color="error"
						type="solid"
						size="m"
						onClick={handleModalConfirm}
						aria-label={t('nastaveni-upozorneni.souhlas-povolit')}>
						{t('nastaveni-upozorneni.souhlas-povolit')}
					</Button>
				</>
			}>
			<MarkdownRender>
				{t(
					'nastaveni-upozorneni.souhlas-se-vstupovanim-do-schranky-popis-dusledku'
				)}
			</MarkdownRender>
		</Dialog>
	);
};
